import { createNewPassword, validateLogin, getSession, sendEmailRecoverPassword } from "../../services/auth.service";
import { actionTypes } from "../contants/actionTypes";

//#region CHECKING_SESSION
export const startCheckingAuthSession = () => ({
    type: actionTypes.authStartCheckingSession
});

export const finishCheckingAuthSession = () => ({
    type: actionTypes.authFinishCheckingSession
});

export const getAuthSession = (userPool) => (
    async (dispatch) => {
        dispatch(startCheckingAuthSession());
        await getSession(userPool)
            .then((userSession) => {
                dispatch(loadDataLogin(userSession))
            }
            ).catch((e) => {
                console.log('error', e)
                dispatch(errorCheckingAuthSession());
            }).finally(() => {
                dispatch(finishCheckingAuthSession());
            });
    }
);

export const errorCheckingAuthSession = () => ({
    type: actionTypes.authErrorCheckingSession
});
//#endregion

//#region CHECKING_LOGIN
export const startCheckingLogin = () => ({
    type: actionTypes.authStartCheckingLogin
});

export const finishCheckingLogin = () => ({
    type: actionTypes.authFinishCheckingLogin
});

export const initializingLogin = (username, password) => (
    async (dispatch) => {
        dispatch(errorLogging(''));
        dispatch(startCheckingLogin());

        await validateLogin(username, password)
            .then(response => {
                console.log('response ', response);
                if (response?.status === 202) {
                    return dispatch(requiredPasswordChange(true, response?.data?.token));
                }
                const userData = {
                    session: response.data,
                    username,
                    accessDate: new Date().getTime()
                };
                sessionStorage.setItem('user', JSON.stringify(userData));
                dispatch(loadDataLogin(userData));
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(setNotificaction({
                        isNotification: true,
                        msg: 'Usuario o contraseña incorrectos, por favor revise las credenciales',
                        typeMsg: 'info'
                    }));
                } else if (e?.response?.status === 402) {
                    dispatch(setNotificaction({
                        isNotification: true,
                        msg: 'Su cuenta se encuentra bloqueada, por favor comuníquese con el área encargada',
                        typeMsg: 'info'
                    }));
                } else {
                    console.error('Error de login', e);
                }
            })
            .finally(() => {
                dispatch(finishCheckingLogin());
            });
    }
);

export const restoreSession = () => async (dispatch) => {
    const storedUser = sessionStorage.getItem('user');
    if (storedUser) {
        try {
            const userData = JSON.parse(storedUser);
            dispatch(loadDataLogin(userData));
        } catch (err) {
            sessionStorage.removeItem('user');
            dispatch(logout());
        }
    }
};

export const loadDataLogin = (userSession) => {
    return {
        type: actionTypes.authLoadDataLogin,
        payload: {
            accessDate: new Date().getTime(),
            username: userSession.username,
            ...userSession.session
        }
    }
};

export const errorLogging = (messageError) => ({
    type: actionTypes.authErrorLogging,
    payload: messageError
});
//#endregion

//#region PASSWORD_CHANGE
export const requiredPasswordChange = (passwordChangeRequired, tokenTemporal) => ({
    type: actionTypes.authPasswordChangeRequired,
    payload: {
        tokenTemporal,
        passwordChangeRequired
    }
});
export const startCreatingNewPassword = () => ({
    type: actionTypes.authStartCreatingNewPassword
});

export const finishCreatingNewPassword = () => ({
    type: actionTypes.authFinishCreatingNewPassword
});

export const forcePasswordChange = () => ({
    type: actionTypes.authForceChangePassword
});

export const changePassword = (TokenTmp, newPassord, user_restore) => (
    async (dispatch) => {
        dispatch(startCreatingNewPassword());
        await createNewPassword(TokenTmp, newPassord)
            .then(response => {
                dispatch(requiredPasswordChange(false, ''));
                dispatch(initializingLogin(user_restore, newPassord));
            }
            ).catch((e) => {
                console.log('error', e)
            }).finally(() => {
                dispatch(finishCreatingNewPassword());
            });
    }
);

export const RecoverPassword = (userName) => (
    async (dispatch) => {
        await sendEmailRecoverPassword(userName)
            .then(response => {
                console.log('response', response)
            }
            ).catch((e) => {
                console.log('error', e)
            }).finally(() => {
                dispatch(finishCreatingNewPassword());
            });
    }
)

//#endregion

export const logout = () => ({
    type: actionTypes.authLogout
});

export const checkAuthToken = () => {

    return async (dispatch) => {
        const user = localStorage.getItem('user');

        if (!user || !user?.token) {
            return dispatch(logout());
        }
        await checkAuthToken(user.token)
            .then(
                response => {
                }
            ).catch((e) => {

            }).finally(() => {
            });
    }

}

export const setNotificaction = (data) => ({
    type: actionTypes.notificaction,
    payload: data
})